
import { Component, Prop, Vue } from 'vue-property-decorator';
import { PlanInterface } from '@/services/Plan/interfaces';

@Component
export default class CreatePlanDialog extends Vue {
  public name: string = '';

  public quota: number = 0;

  public bandwidth: number = 0;

  public websiteCount: number = 1;

  public visible: boolean = true;

  public get valid(): boolean {
    return this.name.trim() !== '' && this.name.length > 2 && !!this.quota;
  }

  public destroyComponent(): void {
    this.$emit('close');
    this.visible = false;
  }

  public async createPlan(): Promise<void> {
    this.$emit('createPlan', this.name, this.quota, this.bandwidth, this.websiteCount);
    this.destroyComponent();
  }
}
